class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.externalInput = this.querySelector('#search');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.externalInput?.addEventListener('focus', () => !this.isOpen() && this.open());
    this.querySelector('.modal__close-button').addEventListener('click', this.close.bind(this));
    this.addEventListener('focusout', (event) => {
      if (this.isOpen() && !this.contains(event.relatedTarget)) this.close(false);
    });

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();

    if (!this.isOpen()) {
      this.open();
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open() {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('.search-modal__content, .password-modal__content'),
      this.externalInput || this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    if (document.querySelector('.vlisco-menu__wrapper')?.classList.contains('active') ) {
      document.querySelector('.vlisco-menu__wrapper').classList.remove('active');
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
